const fieldMixin = {
  data() {
    return {
      symbolNamesToReplaceWithSymbols: {
        'LessThan': '<',
        'GreaterThan': '>',
        'Equals': '=',
        'Plus': '+',
        'Minus': '-',
        'Divide': '/',
        'Multiply': '*',
      },
    };
  },
  methods: {
    getFormattedFieldName(fieldName, fieldKey = null, reverse = false) {
      if (fieldKey) return fieldKey;

      let fieldNameToFormat = fieldName && fieldName.toString();
      Object.keys(this.symbolNamesToReplaceWithSymbols).forEach(symbolName => {
        const symbol = this.symbolNamesToReplaceWithSymbols[symbolName];
        if (fieldNameToFormat && (fieldNameToFormat.includes(symbolName) || fieldNameToFormat.includes(symbol))) {
          fieldNameToFormat = reverse ? fieldNameToFormat.replaceAll(symbol, symbolName) : fieldNameToFormat.replaceAll(symbolName, symbol);
        }
      });

      return fieldNameToFormat || fieldName;
    },
  },
};

export default fieldMixin;